import { api } from 'boot/axios.js'
import { getCookies } from 'boot/cookies.js'

export async function login(ctx, data) {
  try {
    const response = await api({
      url: 'auth/token',
      method: 'post',
      data: data
    })

    const options = {
      secure: process.env.PROD,
      expires: parseInt(response.data.tokenLife) / 60 / 1000
    }

    const cookies = getCookies

    cookies.set('auth_token', response.data.token, options)
    cookies.set('auth_token_life', response.data.tokenLife, options)
    cookies.set('auth_token_type', response.data.type, options)

    options.expires = parseInt(response.data.refreshTokenLife) / 60 / 1000
    cookies.set('refresh_token', response.data.refreshToken, options)
    cookies.set('refresh_token_life', response.data.refreshTokenLife, options)

    ctx.commit('isAuthenticated', true)

    api.defaults.headers.common['Authorization'] =
      'Bearer ' + response.data.token

    return response
  } catch (e) {
    return e
  }
}

export async function recover(ctx, data) {
  try {
    const response = await api({
      url: 'auth/recover-password',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    return e
  }
}

export async function reset(ctx, data) {
  try {
    const response = await api({
      url: 'auth/reset-password',
      method: 'post',
      data: data
    })
    return response
  } catch (e) {
    return e
  }
}

export async function logout(ctx, data = {}) {
  try {
    const response = await api({
      url: 'auth/revoke',
      method: 'post',
      data: data
    })

    const cookies = getCookies

    cookies.remove('auth_token')
    cookies.remove('auth_token_life')
    cookies.remove('auth_token_type')

    cookies.remove('refresh_token')
    cookies.remove('refresh_token_life')

    ctx.commit('isAuthenticated', false)

    delete api.defaults.headers.common['Authorization']

    return response
  } catch (e) {
    return e
  }
}

export function clear(ctx) {
  ctx.commit('isAuthenticated', false)

  const cookies = getCookies

  cookies.remove('auth_token')
  cookies.remove('auth_token_life')
  cookies.remove('auth_token_type')
  cookies.remove('refresh_token')
  cookies.remove('refresh_token_life')

  delete api.defaults.headers.common['Authorization']
}

export function isAuthenticated(ctx, data) {
  ctx.commit('isAuthenticated', data)
}
